<script setup>
import {useModalStore} from "../../../store/modal";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref} from "vue";
import {useCallStore} from "../../../store/calls.js";

const loading = ref(false)
const callStore = useCallStore()
const modalStore = useModalStore()
const is_complete = ref(false)
const callIds = computed(() => modalStore.props.call_ids || [])
const callCount = computed(() => callIds.value.length)

const heading = computed(() => {
    if (is_complete.value) {
        return `${callCount.value} call(s) completed.`
    } else {
        return `Are you sure you want to complete ${callCount.value} call(s)?`
    }
})

const completeCalls = async () => {
    loading.value = true
    try {
        await callStore.bulkCompleteCalls(callIds.value)
        is_complete.value = true
        // Refresh the calls list
        await callStore.getCalls({
            sort_direction: 'desc',
            limit: 25,
            page: 1
        })
    } catch (error) {
        console.error('Error completing calls:', error)
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <DefaultModalBase :heading="heading" icon="check-all" :loading="loading" :refresh="is_complete">

        <div class="complete-call-actions">
            <brand-button @click="completeCalls()" v-if="!is_complete">Yes, mark {{ callCount }} call(s) as complete</brand-button>
            <brand-button variant="secondary" @click="modalStore.close(is_complete)">{{ !is_complete ? "Nevermind" : "Done" }}</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.complete-call-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>

